import React from 'react';

export default function ErrorLoggedOutPage() {

  return (
      <div className="lo-page lo-prose">
        <div className="lo-page-header">
          <h1>Error</h1>
        </div>

        <p>
          <strong>Something went wrong.</strong>{' '}
          Please <a href="https://go.nzyme.org/contact" target="_blank">contact us</a> if this error does not
          resolve itself.
        </p>
      </div>
  )

}
